<template>
  <div class="main-wrapper">
    <cookie-law buttonText="OK" theme="surfverse">
      <div slot-scope="props">
        <p>
          {{ $t('title') }}
        </p>
        <div class="d-flex justify-content-end">
          <router-link to="/legal/cookies-policy" class="more-link mr-2">
            <button class="skew mdc-button mdc-button--outline">
              <span class="mdc-button__ripple"></span>{{ $t('details') }}
            </button>
          </router-link>
          <button
            class="skew mdc-button mdc-button--unelevated"
            @click="props.accept"
          >
            <span class="mdc-button__ripple"></span>{{ $t('accept') }}
          </button>
        </div>
        <!-- <button class="skew mdc-button">
          <span class="mdc-button__ripple"></span>{{ $t('accept') }}
        </button> -->
      </div>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'

export default {
  components: {
    CookieLaw
  }
}
</script>

<i18n>
{
  "en": {
    "title": "We serve cookies on this site to analyze traffic, remember your preferences, and optimize your experience. By using this website, you agree to our cookie policy. 🍪",
    "details": "More details",
    "accept": "OK"
  },
  "ro": {
    "title": "Acest site utilizează cookie-uri pentru a analiza traficul, a vă păstra preferințele și a vă optimiza experiența. Folosind acest site, sunteți de acord cu politica noastră privind cookie-urile. 🍪",
    "details": "Mai multe detalii",
    "accept": "OK"
  },
  "de": {
    "title": "Wir liefern Cookies auf dieser Website, um den Datenverkehr zu analysieren, Ihre Vorlieben zu speichern und Ihre Erfahrung zu optimieren. Durch die Nutzung dieser Website stimmen Sie unseren Cookie-Richtlinien zu. 🍪",
    "details": "Mehr Details",
    "accept": "OK"
  }
}
</i18n>

<style>
.Cookie--surfverse {
  color: var(--nav-link-text) !important;
  padding: 1.25em !important;
  box-shadow: 0 13px 27px -5px rgba(50, 50, 93, 0.25),
    0 8px 16px -8px rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  background-color: var(--navbar-bg) !important;
  -webkit-transition: background-color 0.5s cubic-bezier(0.28, 0.11, 0.32, 1);
  transition: background-color 0.5s cubic-bezier(0.28, 0.11, 0.32, 1);
}
.Cookie--bottom {
  bottom: 24px !important;
  right: 24px !important;
  left: unset !important;
  border-radius: 4px !important;
}
a.more-link {
  font-weight: 500;
  color: var(--nav-link-text);
}
.Cookie {
  width: 400px !important;
  flex-flow: column !important;
}
.Cookie > * {
  align-self: flex-end !important;
}
.Cookie--base .Cookie__button {
  background: #171719;
}
@media (max-width: 991.98px) {
  .Cookie {
    width: 100% !important;
    flex-flow: row !important;
  }
  .Cookie--bottom {
    bottom: 0 !important;
    right: 0 !important;
    left: 0 !important;
    border-radius: 0;
  }
}
</style>
